// FAB sits above the report-card print button (zIndex 1000) so it isn't shoved
// off-screen when both mount; the panel rides above the FAB.
export const FAB_Z_INDEX = 1100;
export const PANEL_Z_INDEX = 1200;

export const PANEL_WIDTH = 400;
export const PANEL_HEIGHT = 560;

export const PROXY_PATH = '/chatbot/chat';
export const STARTERS_PATH = '/chatbot/starters';
